import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  agent: null,
  sharingAgent: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_AGENT:
      return {
        ...state,
        agent: action.agent,
        sharingAgent: action.sharing
      }
    default:
      return state
  }
}

export default reducer
